"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimOwnerAndDepositInstructions = void 0;
const sdk_1 = require("./sdk");
const api_1 = require("./api");
const solana_spl_token_modern_1 = require("solana-spl-token-modern");
const vsr_client_1 = require("./vsr-client");
const claimAndDepositInstruction_1 = require("./claimAndDepositInstruction");
const claimOwnerInstructions_1 = require("./claimOwnerInstructions");
/**
 * Generate instruction calling the `claimAndDeposit`
 * that does the both actions as once as the instruction do CPI call.
 *
 * The claimAndDeposit instruction of the contract requires
 * a VSR voter to exist before the call. This state is verified from chain
 * and this SDK call adds the required create ix before the claimAndDeposit call.
 * On top the SDK searches the deposit entries of the VSR voter
 * and verifies there is an entry represented by the mint with the expected lockup time 30 days.
 * When there is no such entry, the SDK adds the configure deposit entry call.
 *
 * @type {Object} args - Arguments on instruction creation
 * @param param {IncentivesDistributionProgram} args.program - anchor program instance
 * @param param {PublicKey} args.treasuryAccount - incentives distribution program treasury account
 * @param param {PublicKey} args.authority - claim record authority [SIGNER]
 * @param param {PublicKey} args.mint - mint that is used for the deposit entry
 * @param param {PublicKey} args.realm - realm address the VSR registrar account belongs to
 * @type {Object} return - Return instructions
 * @return {TransactionInstruction[]} return.instructions - Instructions to manage claimAndDeposit
 */
async function claimOwnerAndDepositInstructions({ program, authority, mint = vsr_client_1.MNDE_MINT, treasuryAccount = sdk_1.STAKERS_TREASURY, realm = vsr_client_1.MNDE_REALM_ADDRESS, }) {
    const provider = program.provider;
    const instructions = [];
    const { tokenStore } = await (0, api_1.treasury)({ program, address: treasuryAccount });
    if (!mint) {
        // eslint-disable-next-line @typescript-eslint/no-extra-semi
        ;
        ({ mint } = await (0, solana_spl_token_modern_1.getAccount)(provider.connection, tokenStore));
    }
    const { instructions: prepInstructions, depositEntryIndex } = await (0, claimOwnerInstructions_1.vsrPreparationInstructions)({
        program,
        vsrProgramId: vsr_client_1.MNDE_VSR_PROGRAM_ID,
        realm,
        mint,
        authority,
    });
    instructions.push(...prepInstructions);
    // let's claim available tokens from the incentive program to ATA
    const { instruction: claimAndDepositIx, address: claimRecordAddress } = await (0, claimAndDepositInstruction_1.claimAndDepositInstruction)({
        program,
        treasuryAccount,
        tokenStore,
        tokenMint: mint,
        claimRecordAuthority: authority,
        depositEntryIndex,
    });
    instructions.push(claimAndDepositIx);
    return { address: claimRecordAddress, instructions };
}
exports.claimOwnerAndDepositInstructions = claimOwnerAndDepositInstructions;
//# sourceMappingURL=claimOwnerAndDepositInstructions.js.map